<ng-template #tabItemTemplate>
  <ng-content></ng-content>
</ng-template>
